import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useVerifyEmailMutation } from '../../api/auth.js';
import Splash from '../../components/layout/Splash.jsx';

const VerifyEmail = () => {
    const [verifyEmail] = useVerifyEmailMutation();
    const navigate = useNavigate();
    const [queryString] = useSearchParams();
    const initialized = useRef(false);

    const token = queryString.get('token') || '';
    const hash = queryString.get('hash') || '';

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;
            const sendVerifyEmail = async () => {
                await verifyEmail({
                    token,
                    hash
                }).then((apiResponse) => {
                    if (apiResponse.data?.success) {
                        navigate('/validate');
                    }
                });
            };

            sendVerifyEmail().then(() => {
                navigate('/');
            });
        }
    }, [token, hash, navigate, verifyEmail]);

    return <Splash />;
};

export default VerifyEmail;
